/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card favorite instance
 *
 * @module enervee_utils.product_card
 */
function productCardFavoriteDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '='
        },
        controller: productCardFavoriteController,
        template: require('./favoriteView.html')
    };
}

productCardFavoriteController.$inject = [
    '$scope',
    'AnalyticsService',
    'DisclosuresModalService',
    'ProductService',
    'UtilService'
];
function productCardFavoriteController(
    $scope,
    AnalyticsService,
    DisclosuresModalService,
    ProductService,
    UtilService
) {
    $scope.icon = UtilService.getIconClass('favorite', 'bell');
    ProductService.isFavored($scope.product.id).then(function (isFavored) {
        $scope.isProductFavored = isFavored;
    });

    $scope.likeProduct = function (productId, event) {
        event.preventDefault();
        event.stopPropagation();

        ProductService.likeProduct(productId).then(function() {
            ProductService.isFavored(productId, true).then(function (isFavored) {
                $scope.isProductFavored = isFavored;

                var eventType = 'product added';
                if (isFavored) {
                    DisclosuresModalService.openFavoriteProductModal();
                } else {
                    eventType = 'product removed';
                }
                AnalyticsService.reportEvent('Product Favorites Engaged', {
                    type: eventType,
                }, $scope.product);
            });
        });
    };
}

module.exports = productCardFavoriteDirective;